<template>
    <div>
        <div>
            <v-select :options="users"
                      placeholder="Select User"
                      v-model="selectedUserId"
                      class="v-select-styling"
                      label="fullname"
                      :reduce="users => users.id"
                      @input="user_selected"></v-select>
        </div>
        <div>
            <div v-if="userConnectors.length" style="padding-top: 10px">
                <table class="connector-table" style="width:100%">
                    <thead>
                    <th style="width: 20%">Connector</th>
                    <th>Actions</th>
                    </thead>
                    <tbody>
                    <tr v-if="userConnectors" v-for="(conn, idx) in userConnectors" :key="conn.id">
                        <td><img style="width: 20px"
                                 :src="serviceLogo(conn.service)"> {{ conn.service }}
                        </td>
                        <td><a href="#" @click="clearConnector(conn.id, idx)">Clear</a></td>
                    </tr>
                    </tbody>
                </table>
                <div style="display: flex; justify-content: flex-end; padding-top: 10px">
                    <button class="bbutton" @click="clearAll">Clear All</button>
                </div>
            </div>
            <div v-else>User has no connectors!</div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import "vue-select/dist/vue-select.css";

export default {
    name: "AdminUserConnectorSettings",
    data () {
        return {
            'selectedUserId': this.user.id,
            'userConnectors': []
        };
    },
    mounted () {
        this.selectedUserId = this.user.id;
        this.getUserConnectors();
    },
    methods: {
        user_selected: function () {
            if (!this.selectedUserId) return;
            this.getUserConnectors();
        },
        getUserConnectors: function () {
            axios.get(`/admin/user/${this.selectedUserId}/connectors`)
                .then(response => {
                    this.userConnectors = JSON.parse(response.data.connectors);
                }).catch((error) => {
                alert('Something went wrong...');
            });
        },
        serviceLogo: function (service) {
            return `/images/connector-logos/${service}.png`;
        },
        clearConnector: function (connId, idx) {
            this.clearConnectorRequest([connId]).then(data => {
                this.userConnectors.splice(idx, 1);
            }).catch(err => {
                alert("Something went wrong...");
            });
        },
        clearAll: function () {
            this.clearConnectorRequest(Array.from(this.userConnectors, x => x.id)).then(data => {
                this.userConnectors = [];
            }).catch(err => {
                alert("Something went wrong...");
            });
        },
        clearConnectorRequest: function (connectors) {
            return new Promise((resolve, reject) => {
                axios.post(`/admin/user/${this.selectedUserId}/connector/delete`, {
                    'action': 'delete',
                    'userConnectorIds': connectors
                })
                    .then(response => {
                        resolve(response);
                    }).catch((error) => {
                    reject(error);
                });
            });

        }
    },
    props: [
        'user',
        'users'
    ],
};
</script>

<style scoped>
.connector-table {
    border: solid 1px #DDEEEE;
    border-collapse: collapse;
    border-spacing: 0;
}

.connector-table thead th {
    background-color: #035288;
    color: #ECF7FF;
    padding: 10px;
    text-align: left;
}

.connector-table tbody td {
    border: solid 1px #DDEEEE;
    color: #333333;
    padding: 10px;
}
</style>
